module.exports = __webpack_public_path__ + "static/media/customer.929fa305.svg";